import { render, staticRenderFns } from "./giftDialog.vue?vue&type=template&id=d3a545c4&scoped=true&"
import script from "./giftDialog.vue?vue&type=script&lang=js&"
export * from "./giftDialog.vue?vue&type=script&lang=js&"
import style0 from "./giftDialog.vue?vue&type=style&index=0&id=d3a545c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3a545c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3a545c4')) {
      api.createRecord('d3a545c4', component.options)
    } else {
      api.reload('d3a545c4', component.options)
    }
    module.hot.accept("./giftDialog.vue?vue&type=template&id=d3a545c4&scoped=true&", function () {
      api.rerender('d3a545c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/giftActivity/giftDialog.vue"
export default component.exports